import React from 'react'
import { connect } from 'react-redux'
import LoadingSection from '../../../components/loadingSection'
import { selectProductPackageLoading } from '../../../reducers/productPackages'
import classnames from 'classnames'
import {
  selectRefiAppCreditUiState,
  selectCreditSessionFinished,
  selectCurrentRefiApplication,
  selectCurrentRefiUser,
} from '../../../reducers'
import { toggleCreditUiState } from '../refiActions'
import { User } from '../../../core/types'
import { Callback } from '../../../utils/types'

import SelectTradeline from './selectTradeline'
import VscProductsSelection from './vscProductsSelection'
import MembershipAndGapSelection from './membershipAndGapSelection'
import LoanOverview from './loanOverview'
import ReviewAndConfirmLoan from './reviewAndConfirmLoan'
import CreditApplicationChoice from './creditApplicationChoice'
import { RefiApp } from '../types'
import SoftPull from '../profile/softPull'

export interface Props {
  user: User
  toggleCreditUiState: Callback
  uiStatus: boolean
  creditSectionFinished: boolean
  refiApp: RefiApp
  /** Loading state while creating or updating a product package */
  isCreatingPackage: boolean
}

const getButtonClasses = (uiStatus: boolean) => {
  return classnames('refi-app__section-header__button', {
    'refi-app__section-header__button--open': uiStatus,
  })
}
const getSectionClasses = (uiStatus: boolean) => {
  return classnames('', {
    'refi-app__section--open': uiStatus,
  })
}

export const CreditApplicationSection = ({
  toggleCreditUiState,
  uiStatus,
  creditSectionFinished,
  user,
  refiApp,
  isCreatingPackage,
}) => {
  const renderSection = (sectionName) => {
    switch (sectionName) {
      case 'SoftPull':
        return <SoftPull />
      case 'SelectTradeline':
        return <SelectTradeline />
      case 'LoanOverviewComponent':
        return <LoanOverview />
      case 'MembershipAndGapProduct':
        return <MembershipAndGapSelection />
      case 'VscProducts':
        return <VscProductsSelection />
      case 'ReviewAndConfirm':
        return <ReviewAndConfirmLoan />
      case 'Loading':
        return <div>Loading...</div>
      default:
        return <CreditApplicationChoice />
    }
  }

  return (
    <LoadingSection isLoading={isCreatingPackage}>
      <div className={getSectionClasses(uiStatus)}>
        {user.id && !refiApp.rejectedCreditApplication ? (
          <>
            <div
              className="refi-app__section-header"
              onClick={() => toggleCreditUiState()}
              data-test="refiCreditToggle"
            >
              <h2>Pre-Qualification</h2>
              <button className={getButtonClasses(uiStatus)}>Toggle</button>
              <hr className="form__hr" />
            </div>
            {uiStatus &&
              !creditSectionFinished &&
              renderSection(refiApp.creditApplicationStep)}
          </>
        ) : null}
      </div>
    </LoadingSection>
  )
}

export const mapStateToProps = (state) => ({
  user: selectCurrentRefiUser(state),
  uiStatus: selectRefiAppCreditUiState(state),
  creditSectionFinished: selectCreditSessionFinished(state),
  refiApp: selectCurrentRefiApplication(state),
  isCreatingPackage: selectProductPackageLoading(state),
})

export default connect(mapStateToProps, {
  toggleCreditUiState,
})(CreditApplicationSection)
